/* group.tsx generated by @compiled/babel-plugin v0.36.1 */
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["data"];
import "./group.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@compiled/react';
import { cleanCommonProps, getStyleProps } from '../../utils';
var styles = {
  root: "_n3tdu2gc _ca0qu2gc"
};
export var groupCSS = function groupCSS() {
  return {};
};
var Group = function Group(props) {
  var children = props.children,
    builtinCX = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    selectProps = props.selectProps,
    xcss = props.xcss;
  var _getStyleProps = getStyleProps(props, 'group', {
      group: true
    }),
    css = _getStyleProps.css,
    className = _getStyleProps.className;
  return /*#__PURE__*/React.createElement("div", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    style: css
  }, innerProps, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    className: ax([styles.root, cx(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')])
  }), label && /*#__PURE__*/React.createElement(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: builtinCX
  }), label), /*#__PURE__*/React.createElement("div", null, children));
};
var headingStyles = null;
export var groupHeadingCSS = function groupHeadingCSS() {
  return {};
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var GroupHeading = function GroupHeading(props) {
  var xcss = props.xcss;
  var _cleanCommonProps = cleanCommonProps(props),
    data = _cleanCommonProps.data,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded);
  var _getStyleProps2 = getStyleProps(props, 'groupHeading', {
      'group-heading': true
    }),
    css = _getStyleProps2.css,
    className = _getStyleProps2.className;
  return /*#__PURE__*/React.createElement("div", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    className: ax(["_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw", cx(className, xcss, '-group')])
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: css
  }, innerProps));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Group;